// Copyright (c) Docugami, Inc. All rights reserved.

import { ReactNode } from "react";
import styled from "styled-components";

const WorkPathStepCanvasContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
`

interface WorkPathStepCanvasProps {
    children: ReactNode | ReactNode[];
    className?: string;
}

/**
 * Wrapper component for adding usage metrics for work path steps
 */
export const WorkPathStepCanvas = (props: WorkPathStepCanvasProps): JSX.Element => {
    return (
        <WorkPathStepCanvasContainer className={props.className}>
            {props.children}
        </WorkPathStepCanvasContainer>
    )
}
